'use client';

import { JWT_KEY } from 'src/utils/constant';
import SafeStorage from 'src/utils/safe-storage';
import axios, { endpoints } from 'src/utils/axios';
import { requestNotificationPermission } from 'src/utils/media';

import { setSession, setUserSession } from './utils';

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async ({ username, password }) => {
  try {
    const params = { username, password };

    const res = await axios.post(endpoints.auth.signIn, params);

    const accessToken = res.data.access;
    const user_details = res.data.user;
    const agent = user_details?.uuid || undefined;
    // console.log("response here",res.data.data.access_token)
    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    setSession(accessToken, agent);
    setUserSession(user_details);

    requestNotificationPermission();
  } catch (error) {
    console.error('Error during sign in:', error);
    throw error;
  }
};

/** **************************************
 * Sign up
 *************************************** */
export const signUp = async ({ email, password, firstName, lastName }) => {
  const params = {
    email,
    password,
    firstName,
    lastName,
  };

  try {
    const res = await axios.post(endpoints.auth.signUp, params);

    const { accessToken } = res.data;

    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    SafeStorage.setSessionItem(JWT_KEY, accessToken);
  } catch (error) {
    console.error('Error during sign up:', error);
    throw error;
  }
};

/** **************************************
 * Sign out
 *************************************** */
export const signOut = async () => {
  try {
    await setSession(null, null);
    await setUserSession(null);
  } catch (error) {
    console.error('Error during sign out:', error);
    throw error;
  }
};
